import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserGuideIcon from "../../../assets/images/guide.png";
import useUserStore from "../../../utils/storeApp";
import CallAPI from "../../../services/apiCalls";
import TwoFactorPreReg from "../TwoFactorPreReg";
import $ from "jquery";
import validEmail from "../../../utils/emailUtils";

const o = {
  ParentOrganizationId: 0,
  FirstName: "",
  NamePrefix: null,
  LastName: "",
  UserName: "",
  ContactEmail: "",
  RequireIdVerification: false,
  DirectEmail: false,
  Administrator: false,
  TrustedAgent: false,
  CreateUsers: false,
  Credential: "",
  ParentVendorId: "",
  UserType: null,
  TFAEmail: "",
  TFAPhone: "",
  TFAOn: false,
  TwoFactorEnabled: false,
};

const FormUserRegistration = () => {
  const { userToken, sharedObject, SetSharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const [submitFlag, SetSubmitFlag] = useState(false);
  const navigate = useNavigate();
  const [processing, SetProcessing] = useState(false);
  const [answers, setAnswers] = useState(o);
  const [custObject, SetCustObject] = useState([]);
  const [orgObj, SetOrgObj] = useState([]);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedOrganization, setSelectedOrganization] = useState("");
  const [customer, setCustomer] = useState(null);
  const [errEmail, SetErrEmail] = useState(false);
  const [uNameErr, SetUNameErr] = useState(false);

  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };

  const GetOrgCustomer = () => {
    let vl = {};
    for (let el of sharedObject.vendorsObj) {
      el.show = true;
      if (el.id == parseInt(userSession.vendor_id)) {
        vl = el;
      }
    }
    setSelectedCustomer(vl);
  };
  const GetOrgs = () => {
    const temp = [];
    for (let el of sharedObject.getOrgsObj) {
      el.show = true;
      temp.push(el);
    }
    SetOrgObj(temp);
  };
  useEffect(() => {
    const listCust = async (id) => {
      let custId =
        userRole !== "SES ADMINISTRATOR" && userRole !== "SYSTEMADMINISTRATOR"
          ? userSession.vendor_id
          : id;
      SetErrEmail(false);
      const temp = [];
      let vl = false;
      for (let el of sharedObject.vendorsObj) {
        el.show = true;
        if (el.id === parseInt(custId)) {
          vl = el;
        }
        temp.push(el);
      }
      SetCustObject(temp);
      let cust = `${custId}-${vl.trustedAgentAgreement}-${vl.twoFactorAuth}`;
      await setAnswers({
        ...answers,
        ParentVendorId: cust,
        RequireIdVerification: true,
      });
      //setAnswer("ParentVendorId", cust);
      setSelectedCustomer(vl);
      if (
        userRole === "SES ADMINISTRATOR" ||
        userRole === "SYSTEMADMINISTRATOR"
      ) {
        CustomerIdSet(id, cust);
      }
    };
    let obj = sharedObject.orgActionObjForUser;
    if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
      listCust(obj.vendorId);
      if (
        userRole !== "SES ADMINISTRATOR" &&
        userRole !== "SYSTEMADMINISTRATOR"
      ) {
        GetOrgs();

        const foundOrganization = sharedObject.getOrgsObj?.find(
          (x) => x.id === obj.id
        );
        setSelectedOrganization(foundOrganization);

        setAnswer("ParentOrganizationId", obj.id);
        GetOrgCustomer();
      } //  else {
      //   CustomerIdSet(obj.vendorId, vendorVal);
      // }
    } else {
      listCust();
      if (
        userRole !== "SES ADMINISTRATOR" &&
        userRole !== "SYSTEMADMINISTRATOR"
      ) {
        GetOrgCustomer();
        GetOrgs();
      }
    }
  }, []);
  useEffect(() => {
    if (sharedObject.AddTfaFlag) {
      setAnswer("TwoFactorEnabled", false);
      SetSharedObject("AddTfaFlag", false);
    }
  }, [sharedObject.AddTfaFlag]);

  const CustomerIdSet = async (el, ParentVendorId) => {
    if (el === "" || el === undefined) {
      SetOrgObj([]);
      return;
    }
    let cust = {};
    for (let els of sharedObject.vendorsObj) {
      if (els.id == el) {
        cust = els;
      }
    }
    setSelectedCustomer(cust);
    setCustomer(el);
    SetProcessing(true);
    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
      SetProcessing(false);

      const foundOrganization = sharedObject.getOrgsObj?.find(
        (x) => x.id === sharedObject.orgActionObjForUser?.id
      );
      setSelectedOrganization(foundOrganization);

      await setAnswers({
        ...answers,
        ParentOrganizationId: sharedObject.orgActionObjForUser?.id,
        ParentVendorId: ParentVendorId,
        RequireIdVerification: true,
      });
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      custObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      custObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustObject(tmp);
  };
  const filterOrganiations = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObj?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObj?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObj(tmp);
  };
  const containsSpacesOrSpecialChars = (str) => {
    let flag = /[^a-zA-Z0-9-_@.]/.test(str);
    return flag;
  };
  const AddUser = async () => {
    SetSubmitFlag(true);
    SetErrCreateMsg(false);
    SetErrEmail(false);
    SetUNameErr(false);
    if (
      !answers?.ParentVendorId &&
      (userRole === "SES ADMINISTRATOR" || userRole === "SYSTEMADMINISTRATOR")
    ) {
      document.getElementById("ParentVendorId").scrollIntoView();
      document.getElementById("ParentVendorId").focus();
      return;
    } else if (
      !answers.ParentOrganizationId &&
      (userRole === "SES ADMINISTRATOR" || userRole === "SYSTEMADMINISTRATOR")
    ) {
      document.getElementById("ParentOrganizationId").scrollIntoView();
      document.getElementById("ParentOrganizationId").focus();
      return;
    } else if (!answers.FirstName) {
      document.getElementById("FirstName").scrollIntoView();
      document.getElementById("FirstName").focus();
      return;
    } else if (!answers.LastName) {
      document.getElementById("LastName").scrollIntoView();
      document.getElementById("LastName").focus();
      return;
    } else if (answers.ContactEmail === "") {
      document.getElementById("ContactEmail").scrollIntoView();
      document.getElementById("ContactEmail").focus();
      return;
    } else if (
      answers.ContactEmail !== "" &&
      !validEmail(answers.ContactEmail)
    ) {
      SetErrEmail(true);
      return;
    } else if (answers?.UserName === "") {
      document.getElementById("UserName").scrollIntoView();
      document.getElementById("UserName").focus();
      return;
    } else if (
      answers?.UserName !== "" &&
      containsSpacesOrSpecialChars(answers?.UserName)
    ) {
      SetUNameErr(true);
      return;
    }
    if (answers.FirstName.length > 20) {
      document.getElementById("FirstName").scrollIntoView();
      document.getElementById("FirstName").focus();
      return;
    }
    let ans = {};
    if (answers.TwoFactorEnabled === true) {
      ans = {
        ...answers,
        TFAEmail: sharedObject.UserPreRegTwoFactor.contactEmail,
        TFAPhone: sharedObject.UserPreRegTwoFactor.phone,
        TFAOn: sharedObject.UserPreRegTwoFactor.tfaOn,
      };
    } else {
      ans = {
        ...answers,
        TFAEmail: "",
        TFAPhone: "",
        TFAOn: false,
      };
    }

    let val = sharedObject.specialties;
    let spec = [
      {
        Classification: val?.classification,
        Code: val?.code,
        Definition: val?.definition,
        Id: val?.id,
        Notes: val?.notes,
        Specialization: val?.specialization,
        Type: val?.type,
      },
    ];
    let answersObj = {
      ...ans,
      Specialties: spec,
      specializationCode: val?.code,
      ParentVendorId: customer,
      UserType: 0,
    };
    SetProcessing(true);
    let call = "/users/CreateUsers";
    const res = await CallAPI(call, answersObj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      navigate("/registration-success");
    } else if (res.status === "SERVERERROR" || res.status === "REGISTRATIONERROR") {
      let msg = res.data;
      let str = "";
      if (typeof msg === "string") {
        str = msg;
      } else {
        str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
      }
      SetErrMsg(str);
      SetErrCreateMsg(true);
      SetProcessing(false);
    }
    // success navigate to={"/registration-success"}
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
    <div className="FormUserRegistration">
      <div className="sp-pad">
        <form className="form-container" aria-label="User Registration">
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" ? null : (
            <>
              <div className="field-wrapper">
                <label htmlFor="ParentVendorId">Customer</label>
                <span className="filter-container dg-clr">
                  <input
                    className="form-control filter-sm"
                    type="search"
                    placeholder="Filter"
                    aria-label="Filter customers"
                    aria-controls="ParentVendorId"
                    onChange={(el) => {
                      filterVendors(el.target.value);
                    }}
                  />
                </span>
                <select
                  size="5"
                  className="form-control"
                  id="ParentVendorId"
                  name="ParentVendorId"
                  required
                  aria-invalid={answers.ParentVendorId === "" && submitFlag}
                  aria-describedby={
                      !answers.ParentVendorId === "" && submitFlag 
                        ? "ParentVendorIdError" 
                        : undefined
                    }
                  onChange={(el) => {
                    setAnswer("ParentVendorId", el.target.value);
                    let val = el.target.value.split("-");
                    CustomerIdSet(val[0], el.target.value);
                  }}
                  value={answers?.ParentVendorId}
                >
                  <option value={``}>Select Customer</option>
                  {custObject?.map((el) => {
                    if (el.show)
                      return (
                        <option
                          key={el.id}
                          value={`${el.id}-${el.trustedAgentAgreement}-${el.twoFactorAuth}`}
                        >
                          {el.name}
                        </option>
                      );
                  })}
                </select>
                {!answers?.ParentVendorId && submitFlag ? (
                  <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true" id="ParentVendorIdError">
                    Customer is required.
                  </div>
                ) : null}
              </div>
            </>
          )}
          <div className="field-wrapper">
            <label htmlFor="ParentOrganizationId">Organization</label>
            <span className="filter-container dg-clr">
              <input
                className="form-control filter-sm"
                type="search"
                placeholder="Filter"
                aria-label="Filter organizations"
                onChange={(el) => filterOrganiations(el.target.value)}
              />
            </span>
            {orgObj.length > 0 ? (
              <select
                size="5"
                className="form-control"
                name="ParentOrganizationId"
                id="ParentOrganizationId"
                required
                aria-invalid={answers.ParentOrganizationId === "" && submitFlag}
                aria-describedby={answers.ParentOrganizationId === "" && submitFlag ? "ParentOrganizationIdError" : undefined}
                onChange={(el) => {
                  setAnswer("ParentOrganizationId", parseInt(el.target.value));
                  const foundOrganization = sharedObject.getOrgsObj?.find(
                    (x) => x.id === parseInt(el.target.value)
                  );
                  setSelectedOrganization(foundOrganization);
                }}
                value={answers?.ParentOrganizationId}
              >
                <option value={``}>Select Organization</option>
                {orgObj?.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
            ) : (
              <div className="watermark-wrapper">No Results</div>
            )}
            {!answers?.ParentOrganizationId && submitFlag ? (
              <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true" id="ParentOrganizationIdError">
                Organization is required.
              </div>
            ) : null}
          </div>
          <div className="field-wrapper spacer-inline spacer-margin5 v-top">
            <label htmlFor="Prefix">Prefix</label>
            <select
              className="form-control field-ext"
              name="Prefix"
              id="Prefix"
              onChange={(el) => {
                setAnswer("NamePrefix", parseInt(el.target.value));
              }}
              value={answers?.NamePrefix}
            >
              <option value="">Select</option>
              <option value={5}>Prof</option>
              <option value={4}>Dr</option>
              <option value={3}>Mrs</option>
              <option value={2}>Miss</option>
              <option value={1}>Mr</option>
              <option value={0}>Ms</option>
            </select>
          </div>
          {/*First Name*/}
          <div className="field-wrapper field-box4">
            <label htmlFor="FirstName">First Name</label>
            <input
              type="text"
              name="FirstName"
              id="FirstName"
              className="form-control"
              autoComplete="given-name"
              required
                aria-invalid={!answers?.FirstName && submitFlag}
                aria-describedby={
                  !answers?.FirstName && submitFlag
                    ? "FirstNameError"
                    : answers?.FirstName?.length > 20 && submitFlag
                    ? "FirstNameLengthError"
                    : undefined
                }
              onChange={(el) => {
                setAnswer("FirstName", el.target.value);
              }}
              value={answers?.FirstName}
            />
            {!answers?.FirstName && submitFlag ? (
              <div className="alert alert-danger" aria-live="assertive" aria-atomic="true" id="FirstNameError">
                First name is required.
              </div>
            ) : null}
            {answers.FirstName.length > 20 && submitFlag ? (
              <div className="alert alert-danger" aria-live="assertive" aria-atomic="true" id="FirstNameLengthError">
                Cannot be more than 20 characters
              </div>
            ) : null}
          </div>
          {/*Last Name*/}
          <div className="field-wrapper field-box2">
            <label htmlFor="LastName">Last Name</label>
            <input
              type="text"
              className="form-control"
              name="LastName"
              id="LastName"
              autoComplete="family-name"
              required
              aria-invalid={answers.LastName === "" && submitFlag}
              aria-describedby={answers.LastName === "" && submitFlag ? "LastNameError" : undefined}
              onChange={(el) => {
                setAnswer("LastName", el.target.value);
              }}
              value={answers?.LastName}
            />
            {!answers?.LastName && submitFlag ? (
              <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true" id="LastNameError">
                Last name is required.
              </div>
            ) : null}
          </div>
          {/*Credential*/}
          <div className="field-wrapper field-box3 v-top">
            <label htmlFor="Credential">Credential</label>
            <input
              className="form-control"
              name="Credential"
              id="Credential"
              autoComplete="off"
              placeholder="Optional"
              onChange={(el) => {
                setAnswer("Credential", el.target.value);
              }}
              value={answers?.Credential}
            />
          </div>
          {/*Username*/}
          <div className="field-wrapper field-box7 v-top ">
            <label htmlFor="UserName">Username</label>
            <input
              className="form-control"
              name="UserName"
              id="UserName"
              autoComplete="username"
              required
              aria-invalid={(answers.UserName === "" || uNameErr) && submitFlag}
              aria-describedby={
                  !answers.UserName === "" && submitFlag
                      ? "UserNameError"
                      : uNameErr &&submitFlag 
                      ? "UserNameInvalidError" 
                      : undefined
                  }
              onChange={(el) => {
                setAnswer("UserName", el.target.value);
              }}
              value={answers?.UserName}
            />
            {!answers?.UserName && submitFlag ? (
              <div className="alert alert-danger" aria-live="assertive" aria-atomic="true" id="UserNameError">
                Username is required.
              </div>
            ) : null}
            {uNameErr && submitFlag ? (
              <div className="alert alert-danger" id="UserNameInvalidError" aria-live="assertive" aria-atomic="true">
                Please enter a valid Username with no spaces, commas, or special
                characters.
              </div>
            ) : null}
          </div>
          {/*Contact Email*/}
          <div className="field-wrapper field-box8 v-top">
            <label htmlFor="ContactEmail">Contact Email</label>
            <input
              className="form-control"
              type="email"
              name="ContactEmail"
              id="ContactEmail"
              autoComplete="email"
              required
              aria-invalid={(answers.ContactEmail === "" || errEmail) && submitFlag}
              aria-describedby={
                  !answers.ContactEmail === "" && submitFlag
                      ? "ContactEmailError"
                      : errEmail && submitFlag 
                      ? "ContactEmailInvalidError" 
                      : undefined
                  }
              placeholder="Non-Direct Email"
              onChange={(el) => {
                setAnswer("ContactEmail", el.target.value);
              }}
              value={answers?.ContactEmail}
            />
            {!answers?.ContactEmail && submitFlag ? (
              <div className="alert alert-danger" aria-live="assertive" aria-atomic="true" id="ContactEmailError">
                Contact email is required.
              </div>
            ) : null}
            {errEmail && submitFlag ? (
              <div className="alert alert-danger" aria-live="assertive" aria-atomic="true" id="ContactEmailInvalidError">
                Please enter a valid email name with more than 4 characters
                long, no spaces, commas, or special characters.
              </div>
            ) : null}
          </div>
          {/*Beginning of Verifications*/}
          <h6 className="field-wrapper title-divider sp-pad9" id="verificationTitle">
            Verification &#38; Webmail
          </h6>
          <fieldset className="field-wrapper" aria-labelledby="verificationLegend">
            <legend id="verificationLegend" className="sr-only">
              Verification and Webmail Options
            </legend>
            <div className="w-lg2 spacer-inline">
              <div>
                <input
                  className="form-control spacer-margin5"
                  type="checkbox"
                  name="RequireIdVerification"
                  id="RequireIdVerification"
                  onChange={(el) => {
                    setAnswer("RequireIdVerification", el.target.checked);
                  }}
                  
                  checked={answers?.RequireIdVerification}
                  disabled={!selectedCustomer.trustedAgentAgreement}
                />
                <label htmlFor="RequireIdVerification">Require ID Proofing</label>
              </div>
              <div>
                <input
                  className="form-control spacer-margin5"
                  type="checkbox"
                  name="DirectEmail"
                  id="DirectEmail"
                  onChange={(el) => {
                    setAnswer("DirectEmail", el.target.checked);
                  }}
                  checked={answers?.DirectEmail}
                />
                <label htmlFor="DirectEmail">Direct Email</label>
              </div>
            </div>
            <div className="user-guide-wrapper">
              <a
                href="#UserGuide"
                data-toggle="collapse"
                aria-expanded="false"
                aria-controls="UserGuide"
              >
                <img
                  className="w-md4"
                  src={UserGuideIcon}
                  alt="User Guide"
                />
              </a>
            </div>
          </fieldset>
          {/*Verification User Guide*/}
          <div className="field-wrapper">
            <div className="collapse text-reg" id="UserGuide">
              <div className="spacer-margin7">
                As an admin, you will find that there are different ways to
                configure your options.
              </div>
              <ul>
                <li>
                  If required by the site settings, user identity has to be
                  verified during registration, unless it is done out-of-band.
                </li>
                <li>
                  Check "Direct Email" box if the user will need individual
                  Direct email account. Not all users need them, for example,
                  administrative users may not need their own Direct email.
                </li>
                <li>
                  Identity of the trusted agent must always be verified on-line
                  or out-of-band.
                </li>
                <li>
                  Trusted agent must always be an administrator and have ability
                  to create users.
                </li>
              </ul>
            </div>
          </div>
          {/*Beginning of Permissions Section*/}
          <h6 className="field-wrapper title-divider sp-pad9" id="permissionsTitle">Permissions</h6>
          <fieldset className="field-wrapper" aria-labelledby="permissionsLegend">
            <legend id="permissionsLegend" className="sr-only">User Permissions</legend>
            <div>
              <input
                className="form-control spacer-margin5"
                type="checkbox"
                name="Administrator"
                id="Administrator"
                onChange={(el) => {
                  setAnswer("Administrator", el.target.checked);
                }}
                checked={answers?.Administrator}
              />
              <label htmlFor="Administrator">Administrator</label>
            </div>
            {(selectedCustomer.trustedAgentAgreement &&
              userRole === "SES ADMINISTRATOR") ||
            userRole === "SYSTEMADMINISTRATOR" ? (
              <div>
                <input
                  className="form-control spacer-margin5"
                  type="checkbox"
                  name="TrustedAgent"
                  id="TrustedAgent"
                  onChange={(el) => {
                    setAnswer("TrustedAgent", el.target.checked);
                  }}
                  checked={answers?.TrustedAgent}
                  disabled={!answers?.Administrator}
                  aria-disabled={!answers?.Administrator}
                  aria-describedby="TrustedAgentHint"
                />
                <label htmlFor="TrustedAgent">Trusted Agent</label>
                <span id="TrustedAgentHint" className="sr-only">
                    Requires ID Proofing permissions
                </span>
              </div>
            ) : null}
            <div>
              <input
                className="form-control spacer-margin5"
                type="checkbox"
                name="CreateUsers"
                id="CreateUsers"
                onChange={(el) => {
                  setAnswer("CreateUsers", el.target.checked);
                }}
                value={answers?.CreateUsers}
                disabled={!answers?.Administrator}
                aria-disabled={!answers?.Administrator}
                aria-describedby="CreateUserHint"
              />
              <label htmlFor="CreateUsers">Create Users</label>
              <span id="CreateUserHint" className="sr-only">
                    Requires Administrator
                </span>
            </div>
            {selectedOrganization?.twoFactorAuth ? (
              <div>
                <input
                  className="form-control spacer-margin5"
                  type="checkbox"
                  name="TwoFactorEnabled"
                  id="TwoFactorEnabled"
                  onChange={(el) => {
                    setAnswer("TwoFactorEnabled", el.target.checked);
                    if (el.target.checked) {
                      $("#TwoFactorPreRegSettingModal").modal("show");
                    }
                  }}
                  checked={answers.TwoFactorEnabled}
                />
                <label htmlFor="TwoFactorEnabled">Two-Factor Authentication</label>
                <span>
                  <a
                    href="#twoFactorInfo"
                    data-toggle="collapse"
                    aria-expanded="false"
                    aria-controls="twoFactorInfo"
                    aria-describedby="twoFactorInfoDesc"
                    aria-label="More information about two-factor authentication"
                  >
                    <i className="bi bi-info-circle" aria-hidden="true"></i>
                  </a>
                </span>
              </div>
            ) : null}
            <div className="collapse text-reg" id="twoFactorInfo" aria-labelledby="twoFactorInfoDesc">
              <p id="twoFactorInfoDesc">
                Two-factor authentication improves your digital security by
                protecting your account with an additional login step. It makes it
                harder for unauthorized users to gain access to an account without
                permission. A solid blue shield (indicating that two-factor
                authentication is on) or a shield with a slash (indicating that
                two-factor authentication is off) will appear next to each user in
                the list grid, depending on their settings. To modify these
                settings, click on the shield icon or adjust the settings in the
                user detail panel.
              </p>
            </div>
            {errCreateMsg ? (
              <div
               id="errCreateMsg"
                className={`alert alert-danger`}
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
                dangerouslySetInnerHTML={{ __html: errMsg }}
              />
            ) : null}
          </fieldset>
          {/*Register Action*/}
          <div className="button-register-container">
            <button
              onClick={(e) => AddUser()}
              type="button"
              className="btn btn-success"
            >
              Register
            </button>
            <Link
              type="button"
              className="btn btn-outline-secondary spacer-margin2"
              to="/Users"
            >
              Cancel
            </Link>
            {processing && (
              <div 
                    className="loader-container" 
                    role="status" 
                    aria-live="polite" 
                    aria-atomic="true"
                    aria-labelledby="loader-id"
                >
                  <div className="spinner" aria-hidden="true"></div>
                  <div className="loading-text" id="loader-id">{loadingText}</div>
              </div>
            )}
          </div>
        </form>
      </div>
      <TwoFactorPreReg />
    </div>
  );
};

export default FormUserRegistration;
